import { z } from 'zod';
import { NotificationCategory, NotificationType } from '@/features/notifications/types/notifications-dto';
import { t } from 'i18next';

export const NotificationsPageFilterFormSchema = z.object({  
  startDate: z
    .date({ message: t('elements.form.startDate.error') })
    .nullable()
    .optional(),
  endDate: z
    .date()
    .nullable()
    .optional(),
  type: z
    .nativeEnum(NotificationType)
    .nullable()
    .optional(),
  category: z
    .nativeEnum(NotificationCategory)
    .nullable()
    .optional(),
}).refine(
  (data) =>
    data.startDate && data.endDate
      ? data.endDate >= data.startDate
      : true,
  {
    message: t('elements.form.datesDifference.error'),
    path: ['endDate'],
  },
);